import api from "../../../api/axios";

// Feature-local POST wrapper for client creation.
//
// Endpoint: POST /api/crm/clients/
// Body:     { first_name, last_name?, phone, email?, type, status?, source?, notes? }
//           (Phase 15 only sends a subset: first_name, last_name, phone,
//            notes, type="buyer" — see plan §11.)
// Auth:     IsAuthenticated. perform_create sets owner=request.user.
// Response 201: ClientDetailSerializer payload.
// Errors:
//   400 — serializer field errors (e.g. required first_name/phone),
//         unique_client_per_owner_phone IntegrityError (surfaces via
//         non_field_errors or bare-string body).
//
// Stateless request wrapper. No cache. No retry. No orchestration.
// Not a repository, not an entity service, not a resource manager —
// per Phase 15 brief Step 2.
export const createClient = (body) =>
  api.post("/crm/clients/", body).then((res) => res.data);
